import axios from "axios";
import router from "@/routes";

export default {
  strict: true,
  namespaced: true,
  state: {
    roles: null,
    secondaryRole: null,
    permissionGoverned: false,
    permissionIsAdmin: false,
    allowedPages: [],
    allowedInterfaces: [],
    governedPages: [],
  },
  getters: {
    roles: (state) => state.roles,
    // predictile
    isPredictile: (state, getters) => () => !!getters.roles && !!getters.roles["predictile"] && getters.roles["predictile"].length > 0,
    isPredictileAdministrator: (state, getters) => () => !!getters.roles && !!getters.roles["predictile"] && getters.hasRole("predictile", ["predictile_administrator"]),
    isPredictileManagement: (state, getters) => () =>
      !!getters.roles && !!getters.roles["predictile"] && getters.hasRole("predictile", ["predictile_administrator", "predictile_management"]),
    isPredictileOperations: (state, getters) => () =>
      !!getters.roles && !!getters.roles["predictile"] && getters.hasRole("predictile", ["predictile_administrator", "predictile_management", "predictile_operations"]),
    // business
    isBusinessAdministrator: (state, getters) => (businessId) => getters.hasRole(businessId, ["business_administrator"]),
    isBusinessManagement: (state, getters) => (businessId) => getters.hasRole(businessId, ["business_administrator", "business_management"]),
    isBusinessOperations: (state, getters) => (businessId) => getters.hasRole(businessId, ["business_administrator", "business_management", "business_operations"]),
    // common
    hasRole: (state) => (organizationId, roles) => {
      var hasAny = false;
      if (state.roles && state.roles[organizationId]) {
        for (let i = 0; i < roles.length; i++) {
          hasAny = hasAny || state.roles[organizationId].indexOf(roles[i]) > -1;
        }
      }
      return hasAny;
    },
    isLocationFiltered: (state, getters, rootState, rootGetters) => {
      var locations = rootGetters["location/locations"];
      var isFiltered = false;

      if (rootGetters["organization/organization"].type === "business") {
        for (let i = 0; i < locations.length; i++) {
          for (const currentRole in getters.roles) {
            if (currentRole === locations[i].businessLocationId) isFiltered = true;
          }
        }
      }
      return isFiltered;
    },
    secondaryRole: (state) => state.secondaryRole,
    isPscSecondaryRole: (state) => state.secondaryRole === "psc",
    isPermissionGoverned: (state) => state.permissionGoverned,
    isPermissionAdmin: (state) => state.permissionIsAdmin,
    canPage: (state) => (pageKey) => {
      if (!state.permissionGoverned || state.permissionIsAdmin) return true;
      return state.allowedPages.indexOf(pageKey) > -1;
    },
    canInterface: (state) => (interfaceKey) => {
      if (!state.permissionGoverned || state.permissionIsAdmin) return true;
      return state.allowedInterfaces.indexOf(interfaceKey) > -1;
    },
    can: (state, getters) => (key) => getters.canPage(key) || getters.canInterface(key),
    isPageGoverned: (state) => (pageKey) => state.permissionGoverned && state.governedPages.indexOf(pageKey) > -1,
  },
  mutations: {
    setRoles(state, payload) {
      state.roles = payload;
    },
    setSecondaryRole(state, payload) {
      state.secondaryRole = payload;
    },
    setPermissions(state, payload) {
      state.permissionGoverned = !!(payload && payload.isGoverned);
      state.permissionIsAdmin = !!(payload && payload.isAdmin);
      state.allowedPages = (payload && payload.pages) || [];
      state.allowedInterfaces = (payload && payload.interfaces) || [];
      state.governedPages = (payload && payload.governedPages) || [];
    },
  },
  actions: {
    init: async (context) => {
      if (!context.rootGetters["cognito/isAuthenticated"]) {
        context.commit("setRoles", null);
        context.commit("setSecondaryRole", null);
        return;
      }
      try {
        const res = await axios.get(`/users/self/roles`);
        const map = {};
        let secondaryRole = null;
        for (const role of res.data) {
          map[role.entityId] = role.roles;
          if (role.secondaryRole !== undefined && role.secondaryRole !== null) {
            secondaryRole = role.secondaryRole;
          }
        }
        context.commit("setRoles", map);
        context.commit("setSecondaryRole", secondaryRole);
        return Promise.resolve();
      } catch (error) {
        if (error.response && error.response.data) {
          const errors = error.response.data;
          const errorList = Array.isArray(errors) ? errors : errors.errors;
          if (Array.isArray(errorList) && errorList.some((e) => e.message === "ACCOUNT_DELETED")) {
            router.push("/login-error");
            return;
          }
        }
        context.commit("setRoles", null);
        context.commit("setSecondaryRole", null);
      }
    },
    clearRoles: async (context) => {
      context.commit("setRoles", null);
      context.commit("setSecondaryRole", null);
      context.commit("setPermissions", null);
    },
    loadPermissions: async (context, businessId) => {
      if (!businessId || !context.rootGetters["cognito/isAuthenticated"]) {
        context.commit("setPermissions", null);
        return;
      }
      try {
        const res = await axios.get(`/businesses/${businessId}/self/permissions`);
        context.commit("setPermissions", res.data);
      } catch (error) {
        context.commit("setPermissions", null);
      }
    },
  },
};
